import { Navigate, Route, Routes } from "react-router-dom";

import ErrorPage from "views/Error/ErrorPage";
import Unauthorized from "views/Unauthorized/Unauthorized";
import AppRoutes from "routes/AppRoutes";
import LoginRoutes from "routes/LoginRoutes";

import NewUserPage from "views/Auth/NewUserPage";
import { MaintenancePage } from "views/Maintenance/MaintenancePage";
import ResetPassword from "views/Auth/ResetPassword/ResetPassword";
import { useEffect } from "react";
import { PrefetchingErrorScreen } from "layouts/Prefetcher";
import AccessDenied from "views/AccessDenied/AccessDenied";
import { AccessDisabled } from "views/AccessDisabled";
import WorkerAccessCardPage from "views/WorkerAccessCard/WorkerAccessCardPage";

export default function App(): JSX.Element {
  useEffect(() => {
    if (window.location.search.includes("translate")) {
      window.location.href = window.location.href.split("?")[0];
    }
  }, []);

  return (
    <Routes>
      <Route path="/">
        <Route index element={<Navigate to="/app/dashboard" replace />} />

        <Route path="auth/*" element={<LoginRoutes />} />

        <Route path="app/*" element={<AppRoutes />} />

        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path="/blocked" element={<PrefetchingErrorScreen />} />

        <Route path="new-user/:token" element={<NewUserPage />} />

        <Route path="/under-maintenance" element={<MaintenancePage />} />

        <Route path="/access-denied" element={<AccessDenied />} />

        <Route path="/access-disabled" element={<AccessDisabled />} />

        <Route path="reset/:token" element={<ResetPassword />} />

        <Route path="worker-access-card" element={<WorkerAccessCardPage />} />

        <Route path="*" element={<ErrorPage />} />
      </Route>
    </Routes>
  );
}
